import { TERMO_ACEITE_LIST_LOAD, TERMO_ACEITE_LIST_UNLOAD } from "../../actions/Constants";

const INITIAL_STATE = { all: [] };

export default function termoAceite(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TERMO_ACEITE_LIST_LOAD:
      return {
        ...state,
        all: action.payload ? action.payload : null,
      };
    case TERMO_ACEITE_LIST_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
